import React, { useState } from 'react';
import { IoClose } from "react-icons/io5";

const QuickAnswerList = ({
  quicklyAnswers,
  onSelectQuickAnswer,
  setIsMedia,
  setIsMediaAnswer,
  setIsMediaTypeAnswer,
  setTextDocument,
  setViewAnswer,
  setInputStr,
  setIdAnswerSelected,
  inputRef,
  getQuickReply,
  isProspects
}) => {
  const [is, setIs] = useState(isProspects ? "75%" : "50%" );
  const [left, setLeft] = useState(isProspects ? "3rem" : "8rem" );

  return (
    <div className="content-answers cont py-1 bg-white position-absolute" style={{ width: is, bottom: "3.5rem", left: left, borderRadius: "12px", border: "1px solid #ccc", zIndex: "9" }}>
      <header className="pl-3 d-flex justify-content-between" style={{borderTopLeftRadius: "12px", borderTopRightRadius: "12px"}}>
        <h4 className="m-0">Respuestas rápidas</h4>
        <IoClose className="pointer" style={{fontSize: "1.4rem"}} onClick={() => setViewAnswer(false)}/>
      </header>

      <div className="px-3 list-quickly-answers" style={{ height: "176px", overflow: "auto" }}>
        {quicklyAnswers.length == 0 ? (
          <div className="text-center mt-3">
            <h3 className="text-center mt-3">Sin respuestas rápidas</h3>
          </div>
        ) : (
          <ul>
            {quicklyAnswers.map((quickly, q) => (
                <li
                  key={q}
                  id="quicklyAnswers"
                  className="pointer py-2 px-1 d-flex justify-content-between align-items-center"
                  style={{borderBottom:"1px solid rgb(0,0,0,.05)", fontSize:"0.9em"}}
                  onClick={() => onSelectQuickAnswer(quickly)}
                  // onClick={() => {
                  //   if (quickly.media){
                  //     setIsMedia(true);
                  //     setIsMediaAnswer(quickly.media)
                  //     setIsMediaTypeAnswer(quickly.mediaType)
                  //     setTextDocument(quickly.content)
                  //     setViewAnswer(false);
                  //     setInputStr("")
                  //     setIdAnswerSelected(quickly._id)
                  //   } else {
                  //     setViewAnswer(false);
                  //     setInputStr(quickly.content)
                  //   }
                  //   if (inputRef.current) {
                  //     inputRef.current.focus();
                  //   }
                  //   getQuickReply()
                  // }}
                >
                  <div style={{display: "grid"}}>
                    <strong>{quickly.name}</strong>
                    {quickly.content.length >= 70 ? quickly.content.substr(0, 70) + " ..." : quickly.content}
                  </div>
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default QuickAnswerList;